<div class="introduction-text" [innerHTML]="introduction | safeHtml"></div>
<button mat-flat-button class="start-button" (click)="onStartSurveyClicked()">
  Start Survey
</button>
